import {ReadAbstract, template as tpl} from "./ReadAbstract";
import {IExportFlow, ITableColumn} from "../../../../index";
import Transform from "../Transform";
import {_} from 'lodash';
import {nsDynamicVariable} from "../../../dynamic-variable/nsDynamicVariable";
import {SyncstepId} from "../../../../constants";
import {getHash} from "../../../../constants/RouteDefinitions";

export let template = tpl;

export class viewModel extends ReadAbstract {
    protected readonly TableColumns: ITableColumn<IExportFlow>[] = [
        {key: "id", sort: true},
        {key: "sourceattribute", label: "source", sort: true, validator: () => this.exportTemplate.syncstep.syncstep.id != SyncstepId.Synchronization},
        {key: "targetattribute", label: "target", sort: true, component: {name: 'component/variable/syncfield-name', params: o => ({objecttypeid: this.exportTemplate.objecttype.id, key: o.targetattribute})}},
        {key: "nullable", label: "empty target", sort: true, yesno: true, validator: () => this.exportTemplate.syncstep.syncstep.id != SyncstepId.Synchronization},
        {key: "updateforcesdeltasync", label: "Start deltasync", sort: true, yesno: true, validator: () => this.exportTemplate.syncstep.syncstep.id != SyncstepId.Synchronization},
        {key: "expression", label: "transformation", sort: true},
        {key: "$ruleset", label: "ruleset", sort: true},
    ];

    protected override getCellContent(key: string, val: any, item: any): string | number | any[] | null {
        if (key == "expression" && val.indexOf("[TRANSFORM;") == 0 && nsDynamicVariable.validateExpression(val)) {
            return new Transform(val).getOutput();
        }

        switch (key) {
            case "$ruleset":
                return item.ruleset
                    ? `<a href="${getHash('rulesetdetails', {id: item.ruleset.id})}" title="${item.ruleset.name} [Regelsett]">${item.ruleset.name}</a>`
                    : null
                    ;
        }

        return super.getCellContent(key, val, item);
    }

    protected override getCellText(key: string, val: any, item: any): string | number | any[] | null {
        const def = this.TableColumns.find((t: ITableColumn<IExportFlow>) => t.key == key);

        switch (key) {
            case "nullable":
                return val ? "yes" : "no";
            case "updateforcesdeltasync":
                 return val ? "yes" : "no";
            case "$ruleset":
                return item?.ruleset?.name ?? null
            case "$fn":
                return "export attribute";
        }

        if (key.indexOf(".") > -1) {
            try {
                val = key.split('.').reduce((o: any, key: string) => o[key], item);
            } catch (err) {
            }
        }

        if (def?.count) {
            return val.length;
        }

        return _.isString(val)
            ? val.replace(/</g, '&lt;').replace(/>/g, '&gt;')
            : val
            ;
    }
}
